export enum ViewGridSummaryBlock {
  Root = 'ViewGridSummary',
}
